export default function splitOnLastSpace(str) {
  const lastSpaceIndex = str.lastIndexOf(' ');
  if (lastSpaceIndex === -1) {return [str, ''];} // No space found
  
  return [
    str.slice(0, lastSpaceIndex),
    str.slice(lastSpaceIndex + 1)
  ];
}